module.exports = __webpack_public_path__ + "img/robotCicada.870f82fc.png";